import {Button} from '@/components/ui/button/Button'
import {Media} from '@/components/ui/media/Media'
import {Modal} from '@/components/ui/modal/Modal'
import {capitalize} from 'lodash'
import {useTranslation} from 'react-i18next'
import {StyledDivider, StyledGif, modalStyles} from './style'
import {useParams} from 'react-router-dom'
import {useMe} from '@/features/authentication/queries/useMe'
import {useRootStore} from '@/store'
import {selectSendGifModal} from '@/store/selectors'
import {ChannelID} from '@/features/chat/types'
import {getChatChannelUserIds, getCorrectUserId} from '@/utilities/helpers'
import {useSendMessageV3} from '@/features/chat/queries/useSendMessageV3'
import {MessageTypeE} from '@/features/chat/chat.model'
import {useGetChannelDetailsV3} from '@/features/chat/queries/useGetChannelDetailsV3'
import {useMemo} from 'react'
import {UserV3} from '@/features/authentication/types'

const SendGifModal = () => {
    const {closeModal, gif} = useRootStore(selectSendGifModal)
    const {t} = useTranslation()
    const gifUrl = !!gif && gif?.images.fixed_height.url
    const {channel} = useParams()
    const {data: user} = useMe()
    const {data: channelDetails} = useGetChannelDetailsV3(channel as ChannelID)
    const {mutate: sendChatMessage, isPending} = useSendMessageV3({chatIdentifier: String(channel)})
    const [guestId, hostId] = useMemo(() => getChatChannelUserIds(`${channel}`), [channel])
    const senderId = getCorrectUserId(user as UserV3)
    const receiverId = Number([guestId, hostId].find(item => item !== String(senderId)))

    const handleSendGif = async () => {
        if (user && senderId && channelDetails && gifUrl) {
            await sendChatMessage({
                message: {
                    type: MessageTypeE.GIF,
                    senderId,
                    receiverId,
                    metadata: {
                        gifUrl
                    }
                },
                representedCreatorId: senderId
            })
        }
        closeModal()
    }
    return (
        <div>
            <Modal title={t('gifs_and_stickers:send_gif')} onClose={closeModal} modalStyles={modalStyles}>
                <StyledGif>
                    <Media radius={10} imageUrl={gifUrl || ''} />
                </StyledGif>
                <StyledDivider />
                <Button type="submit" onClick={handleSendGif} disabled={isPending}>
                    {capitalize(t('common:send'))}
                </Button>
            </Modal>
        </div>
    )
}

export default SendGifModal
